import { gsap } from 'helpers/gsap'

export const onArrowClick = () => {
  // console.dir(5555)
  // let scrollerSmoother = ScrollSmoother.create({
  //   content: '.home-content',
  //   wrapper: '.home-wrapper',
  //   smooth: 1.5,
  // })
  gsap.to(window, {
    duration: 3,
    scrollTo: { y: '#next', offsetY: 0 },
  })
}
